<template>
  <section class="billboard">
    <h1 class="billboard-section-title">En Cartelera</h1>
    <div
      v-if="billboardMovies"
      class="billboard-slider">
      <div
        v-for="movie in billboardMovies"
        :key="movie.id"
        class="billboard-slide">
        <div class="billboard-card">
          <div class="billboard-card-info">
            <figure class="image backdrop">
              <img
                v-if="movie['show-in-carousel'] === '0'"
                :src="movie.backdrop.guid"
                :alt="movie['movie-name']"
                :title="movie['movie-name']"
                width="100w">
              <img
                v-else
                :src="movie.preview.guid"
                :alt="movie['movie-name']"
                :title="movie['movie-name']"
                width="100w">
            </figure>
            <a
              class="button billboard-btn-play-trailer"
              @click="openTrailerModal(movie.trailer)">
              <span class="icon">
                <play-icon/>
              </span>
            </a>
            <h3 class="billboard-title">
              <span class="text">{{ movie['movie-name'] }}</span>
              <span class="more"/>
            </h3>
            <div class="billboard-meta">
              <span class="year">{{ movie.year }}</span>
              <span class="maturity-rating">{{ movie.rating[0] }}</span>
              <span class="duration">{{ movie.runtime }}</span>
            </div>
            <div class="billboard-synopsis">
              <p>{{ movie['short-plot'] }}</p>
              <span class="more"/>
            </div>
            <a
              class="button billboard-btn-more-info"
              @click="openMovieModal(movie)">
              <span class="icon">
                <information-outline-icon/>
              </span>
              <span>Más detalles</span>
            </a>
          </div>
          <div class="billboard-card-media">
            <figure class="image">
              <img
                :src="movie.poster.guid"
                :alt="movie['movie-name']"
                :title="movie['movie-name']"
                width="100w">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import InformationOutlineIcon from 'vue-material-design-icons/InformationOutline.vue';
import PlayIcon from 'vue-material-design-icons/Play.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Billboard',
  components: {
    InformationOutlineIcon,
    PlayIcon,
  },
  computed: {
    ...mapGetters([
      'billboardMovies',
    ]),
  },
  updated() {
    tns({
      container: '.billboard-slider',
      items: 2,
      lazyload: true,
      controls: true,
      mouseDrag: true,
      swipeAngle: false,
      speed: 1000,
      useLocalStorage: false,
      slideBy: 'page',
      gutter: 10,
      responsive: {
        500: {
          items: 3,
        },
        800: {
          items: 4,
        },
        1000: {
          items: 5,
        },
      },
    });
  },
  methods: {
    ...mapActions([
      'openTrailerModal',
      'openMovieModal',
    ]),
  },
};
</script>

<style lang="scss">
@import "~bulma/sass/utilities/initial-variables";
@import "~bulma/sass/utilities/functions";
@import "~bulma/sass/utilities/derived-variables";
@import "~bulma/sass/utilities/mixins";
@import "~@/sass/variables";
@import '~tiny-slider/src/tiny-slider';

.billboard {
  padding-left: 4%;
  margin-bottom: 2rem;

  .billboard-section-title {
    color: lighten($dark-cyan-gray, 30);
    font-weight: bold;
    text-transform: uppercase;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;

    @include from(1000px) {
      font-size: 1.5rem;
    }
  }

  .tns-ovh {
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      overflow: unset;
    }
  }

  .billboard-slider {
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      &:hover {
        .billboard-slide {
          &:hover {
            & ~ .billboard-slide {
              .billboard-card {
                transform: translateX(10%);
              }
            }
          }
        }
        .billboard-card {
          transform: translateX(-10%);
          transition-delay: 0ms;

          &:hover {
            transform: translateX(0);

            .billboard-card-info {
              opacity: 1;

              .billboard-title,
              .billboard-meta,
              .billboard-synopsis,
              .billboard-btn-more-info {
                opacity: 1;
                transition: 200ms;
                transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
                transition-delay: 300ms;
              }

              .billboard-btn-play-trailer {
                opacity: 0.7;
                transition: 200ms;
                transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
                transition-delay: 300ms;

                &:hover {
                  opacity: 1;
                  transition: 200ms;
                  transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
                  transition-delay: 0ms;

                  .icon {
                    color: $brilliant-orange;
                  }
                }
              }

              .billboard-btn-more-info {
                $btn-color: $dark-cyan-blue;
                $btn-color-invert: findColorInvert($dark-cyan-blue);

                &:hover {
                  transition-delay: 0ms;
                  background-color: darken($btn-color, 2.5%);
                  border-color: transparent;
                  color: $btn-color-invert;
                }
              }
            }

            .billboard-card-info, .billboard-card-media {
              width: 120%;
              height: 120%;
              top: -10%;
              left: -10%;
              transition: 400ms;
              transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
              transition-delay: 0ms;
            }
          }
        }
      }
    }

    .billboard-slide {
      width: 50%;
      padding-right: 10px;
      display: inline-block;

      @include from(500px) {
        width: 33%;
      }

      @include from(800px) {
        width: 25%;
      }

      @include from(1000px) {
        width: 20%;
      }
    }
  }

  .billboard-card {
    position: relative;
    display: flex;
    flex-direction: column;

    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      padding-bottom: 150%;
      transition: 400ms;
      transition-delay: 200ms;
      transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
    }

    .billboard-card-media {
      @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
        transition: 400ms;
        transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
        transition-delay: 200ms;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;

        .image {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;

          img {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            widows: 100%;
            height: 100%;
          }
        }
      }

      @media (-moz-touch-enabled: 1), (hover: none) and (pointer: coarse) {
        order: -1;
        position: relative;
        overflow: hidden;

        &:before,
        &:after {
          content: '';
          position: absolute;
          bottom: -1px;
          left: 50%;
          height: 0;
          border-left: 20px solid transparent;
          border-right: 20px solid transparent;
          border-bottom: 10px solid $dark-cyan-blue;
          z-index: 100;
          width: 100%;
          bottom: 0;
          right: 0;
        }

        &:after {
          left: -50%;
        }

        .image {
          padding-bottom: 150%;

          img {
            width: calc(100% - 2px);
            margin-left: 1px;
            height: 100%;
            object-fit: cover;
            position: absolute;
          }
        }
      }
    }

    .billboard-card-info {
      @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
        padding: 0 4% 4% 4%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: flex-start;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        transition: 400ms;
        transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
        transition-delay: 200ms;
        opacity: 0;
        z-index: 1;

        .backdrop {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: -1;

          &:after {
            content: '';
            background-image: linear-gradient(to bottom,
              rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.75) 60%, rgba(0, 0, 0, 0.85) 100%);
            position: absolute;
            left: -2px;
            right: -2px;
            bottom: -2px;
            top: 0px;
          }

          img{
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .billboard-title,
        .billboard-meta,
        .billboard-synopsis,
        .billboard-btn-more-info {
          opacity: 0;
          transition: 200ms;
          transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
          transition-delay: 0ms;
          color: #fff;
        }

        .billboard-synopsis {
          height: calc(1.5 * 4em);
          overflow: hidden;
          position: relative;
          margin-top: 0.5rem;
          margin-bottom: 0.5rem;
          font-size: 0.85rem;

          @include from(700px) {
            font-size: 1rem;
          }

          &:before {
            content: '';
            width: 5px;
            height: calc(1.5 * 4em);
            float: left;
          }

          p {
            float: right;
            width: 100%;
            margin-left: -5px;
          }

          .more {
            width: 50%;
            margin-left: -50%;
            float: right;
            padding-right: 5px;
            position: relative;
            left: 100%;
            top: -1rem;
            box-sizing: content-box;
            background: linear-gradient(to right, rgba(0, 0, 0, 0) 0,
            rgba(0, 0, 0, 0.85) 50%, rgba(0, 0, 0, 1) 100%);
            height: 1rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            @include from(700px) {
              top: -1.5rem;
              height: 1.5rem;
            }

            &:after {
              content: '... \00a0';
              font-size: 1rem;
              margin-top: -0.5rem;
              color: white;
              margin-right: 0.25rem;
            }
          }

          @supports (-webkit-line-clamp: 4) {
            p {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 4;
                -webkit-box-orient: vertical;
            }

            .more {
              display: none;
            }
          }
        }

        .billboard-btn-play-trailer {
          outline: 0;
          border-radius: 50%;
          color: #fff;
          opacity: 0;
          transition: 200ms;
          transition-timing-function: cubic-bezier(0.5, 0, 0.1, 1);
          transition-delay: 0ms;
          border: 1px solid #fff;
          width: 2rem;
          height: 2rem;
          background-color: rgba(0, 0, 0, 0.2);
          margin-bottom: 0.5rem;

          @include from(700px) {
            width: 2.5rem;
            height: 2.5rem;
          }

          svg {
            width: 100%;
            height: 100%;
            margin-bottom: 0;
          }
        }

        .billboard-title {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-weight: bold;
          max-width: 100%;
          font-size: 1rem;
        }

        .billboard-meta {
          display: flex;
          font-size: 0.75rem;
          margin-top: 0.5rem;
          align-items: center;
          font-weight: bold;

          span {
            margin-right: 5px;
          }

          .maturity-rating {
            height: 2em;
            display: inline-flex;
            border-radius: 4px;
            align-items: center;
            justify-content: center;
            line-height: 1.5;
            padding-left: 0.75em;
            padding-right: 0.75em;
            white-space: nowrap;
            border: solid 1px rgba(255,255,255,.4);
          }
        }

        .billboard-btn-more-info {
          font-weight: bold;
          $btn-color: $dark-cyan-blue;
          $btn-color-invert: findColorInvert($dark-cyan-blue);
          $button-focus-box-shadow-size: 0 0 0 0.125em;
          background-color: $btn-color;
          border-color: $btn-color;
          color: $btn-color-invert;
          font-size: 0.85rem;

          @include from(700px) {
            font-size: 1rem;

            .icon {
              span {
                width: 90%;
                height: 90%;
              }
            }
          }

          &:hover,
          &.is-hovered {
            background-color: darken($btn-color, 2.5%);
            border-color: transparent;
            color: $btn-color-invert;
          }

          &:focus,
          &.is-focused {
            background-color: darken($btn-color, 5%);
            border-color: transparent;
            color: $btn-color-invert;

            &:not(:active) {
              box-shadow: $button-focus-box-shadow-size rgba($btn-color, 0.25);
            }
          }

          &:active,
          &.is-active {
            background-color: darken($btn-color, 5%);
            border-color: transparent;
            color: $btn-color-invert;
          }

          .icon {
            margin-right: 0.25rem;
          }
        }
      }

      @media (-moz-touch-enabled: 1), (hover: none) and (pointer: coarse) {
        .backdrop,
        .billboard-btn-play-trailer,
        .billboard-meta,
        .billboard-synopsis, {
          display: none;
        }

        .billboard-title {
          font-size: 0.85rem;
          font-weight: bold;
          padding: 0.25rem 0.5rem;
          background: $dark-cyan-blue;
          color: findColorInvert($dark-cyan-blue);
          height: calc(1.5 * 2.5em);
          overflow: hidden;
          position: relative;

          @include from(700px) {
            font-size: 1rem;
          }

          &:before {
            content: '';
            width: 5px;
            height: calc(1.5 * 2.5em);
            float: left;
          }

          .text {
            color: findColorInvert($dark-cyan-blue);
            float: right;
            width: 100%;
            margin-left: -5px;
          }

          .more {
            width: 50%;
            margin-left: -50%;
            float: right;
            padding-right: 5px;
            position: relative;
            left: 100%;
            top: -1rem;
            box-sizing: content-box;
            background: linear-gradient(to right, rgba(0, 0, 0, 0) 0,
            rgba(0, 0, 0, 0.85) 50%, rgba(0, 0, 0, 1) 100%);
            height: 1rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;

            @include from(700px) {
              top: -1.5rem;
              height: 1.5rem;
            }

            &:after {
              content: '... \00a0';
              font-size: 1rem;
              margin-top: -0.5rem;
              color: findColorInvert($dark-cyan-blue);
              margin-right: 0.25rem;
            }
          }

          @supports (-webkit-line-clamp: 2) {
            .text {
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .more {
              display: none;
            }
          }
        }

        .billboard-btn-more-info {
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          font-weight: bold;
          font-size: 0.85rem;
          width: 100%;

          @include from(700px) {
            font-size: 1rem;
          }

          $btn-color: $dark-cyan;
          $btn-color-invert: findColorInvert($dark-cyan);
          background-color: $btn-color;
          border-color: $btn-color;
          color: $btn-color-invert;
        }
      }
    }
  }

  .tns-nav {
    position: absolute;
    right: 4%;
    top: -2.25rem;

    button {
      appearance: none;
      border: 0;
      padding: 0;
      margin: 0;
      background: #4d4d4d;
      width: 12px;
      height: 2px;
      margin-left: 2px;

      &.tns-nav-active {
        background: #aaa;
      }
    }
  }

  .tns-inner {
    margin-right: 20px !important;
  }

  .tns-outer {
    position: relative;
    @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
      &:hover {
        .tns-controls {
          button {
            display: block;
          }
        }
      }
    }
  }

  .tns-controls {
    button {
      @media (-moz-touch-enabled: 0), (hover: hover) and (pointer: fine) {
        display: none;
      }
      appearance: none;
      border: 0;
      padding: 0;
      margin: 0;
      background: rgba(20,20,20, 0.5);
      width: 3rem;
      height: 3rem;
      margin-top: -1.5rem;
      right: 0;
      position: absolute;
      top: 50%;
      z-index: 1;
      font-size: 0;
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path fill-opacity="0.85" fill="%23fff" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>');
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;

      @media (-moz-touch-enabled: 1), (hover: none) and (pointer: coarse) {
        margin-top: calc(-1.5rem - 1.82rem);
      }

      &:first-of-type {
        left: calc(-4% - 5px);
        right: auto;
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path fill-opacity="0.85" fill="%23fff" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>');
      }
    }
  }
}
</style>
